import { Box, Button, Grid, Link, Typography } from "@mui/material";
import maddyUgc from "assets/home/maddy_ugc.jpg";

import { trackEvent } from "utils/tracking";

const UGCTrainingCard = () => {
  return (
    <Box
      sx={{
        p: 3,
        background:
          "linear-gradient(57.59deg, #151F16 -1.58%, #004537 98.35%), linear-gradient(180deg, rgba(236, 234, 229, 0) 0%, #ECEAE5 100%), #FFFFFF",
        borderRadius: 4,
      }}
    >
      <Grid
        container
        gap={2}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item xs>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: 8,
              mb: 1,
              py: 1,
              px: 2,
              width: "max-content",
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            💎 Learn from a UGC coach
          </Box>
          <Typography
            variant="h4"
            sx={{ color: "yellow.main", fontWeight: 700, mb: 1 }}
          >
            Get paid to travel with UGC (
            <Link
              target="_blank"
              href="https://www.instagram.com/maddyoutdoors.coach/"
              sx={{ color: "yellow.main", textDecoration: "underline" }}
            >
              @maddyoutdoors
            </Link>
            )
          </Typography>
          <Typography sx={{ color: "#ECEAE5", mb: 2, fontSize: 14 }}>
            Click below to watch her free training on how to work with brands,
            hotels, and tourism boards... so you can work less and travel more.
          </Typography>
        </Grid>

        <Grid item xs="auto">
          <Box
            component="img"
            sx={{
              width: { xs: 80, md: 120 },
              borderRadius: "50%",
              mb: 2,
              border: "1px solid white",
            }}
            src={maddyUgc}
          />
        </Grid>
      </Grid>

      <Button
        variant="outlined"
        fullWidth
        href="https://paidtotravel.buzzsprout.com/"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() =>
          trackEvent("Partner Offers View Offer Clicked", {
            Offer: "Maddy Travel UGC",
          })
        }
        sx={{
          borderRadius: 2,
          py: 1,
          color: "white",
          borderColor: "white",
          "&:hover": {
            color: "yellow.main",
            borderColor: "yellow.main",
          },
        }}
      >
        Free travel with UGC training
      </Button>
    </Box>
  );
};

export default UGCTrainingCard;
